import React, { MouseEventHandler, useRef } from 'react';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import CourseRatingView from 'components/common/CourseRatingView';
import UserInfo from 'components/common/UserInfo';
import dayjs from 'lib/dayjs';
import { CourseInfo } from 'service/course';

import styles from './CourseItemView.module.scss';

function CourseItemView({ course }: { course: CourseInfo }): JSX.Element {
  const router = useRouter();
  const userInfoRef = useRef<HTMLDivElement>(null);
  const onCourseClick: MouseEventHandler = (e) => {
    const selection = window.getSelection();
    if (
      selection.type != 'Range' &&
      !userInfoRef?.current?.contains(e.target as HTMLElement)
    ) {
      void router.push(`/courses/${course.id}`);
    }
  };

  return (
    <div className={styles.courseItemView}>
      <div className={styles.thumbnailWrapper}>
        {course.thumbnail_image_media?.url && (
          <Link
            href={`/courses/${course.id}`}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Image
              src={course.thumbnail_image_media.url}
              height={course.thumbnail_image_media?.height * 2}
              width={course.thumbnail_image_media?.width * 2}
              alt="image"
              unoptimized
            />
          </Link>
        )}
      </div>
      <div className={styles.courseInfo} onClick={onCourseClick}>
        <div className={styles.courseInfoHeader}>
          <div ref={userInfoRef}>
            <UserInfo user={course.user} />
          </div>
          <span className={styles.timeSince}>
            {course.published_at &&
              dayjs(course.published_at).format('YYYY年MM月')}
          </span>
        </div>
        <div className={styles.courseInfoBody}>
          <div className={styles.courseTitle}>{course.title}</div>
          <div className={styles.ratingAndCategory}>
            {course.domains && course.domains.length > 0 && (
              <div className={styles.categoryItem}>
                {course.domains[0].name}
              </div>
            )}
            <CourseRatingView
              count={course.review_summary?.count}
              rating={course.review_summary?.rating}
              className={styles.ratingSection}
            />
          </div>
          <div className={styles.description}>{course.description}</div>
        </div>
      </div>
    </div>
  );
}

const MemoizedCourseItem = React.memo(CourseItemView);
export default MemoizedCourseItem;
